import React from "react";
import "./Financials.scss"; // Make sure to import your CSS file
import { useSelector } from "react-redux";
export const FinancialsCard = ({ data }) => {
  const {
    ord_svc_date,
    svc_provider_cost_amt,
    svc_provider_local_cost_amt,
    svc_rating_num,
    s_status_cd,
    svcf_name,
    order_count,
  } = data;
  const { refsdata } = useSelector((state) => state.refstypes);
  const xchange_rate = refsdata.usr?.iso_currency_xchng || [];
  const green_status = new Set([
    "PAID-OUT",
    "PAID",
    "COMPLETED",
    "ACCEPTED",
    "CHECK-IN",
  ]);
  const red_status = new Set([
    "DECLINED",
    "EXPIRED",
    "FAILED",
    "CANCELLED",
    "UNREACHABLE",
  ]);
  const black_status = new Set(["CONTACTED", "SUBMITTED"]);
  const svc_provider_cost_amtf = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(svc_provider_cost_amt);
  const svc_provider_local_cost_amtf = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(svc_provider_local_cost_amt);

  return (
    <div className="facility">
      <h5>
        Order Status -{" "}
        {green_status.has(s_status_cd.toUpperCase()) ? (
          <span className="green1">{s_status_cd.toUpperCase()}</span>
        ) : red_status.has(s_status_cd.toUpperCase()) ? (
          <span className="red">{s_status_cd.toUpperCase()}</span>
        ) : black_status.has(s_status_cd.toUpperCase()) ? (
          <span className="black">{s_status_cd.toUpperCase()}</span>
        ) : (
          <span className="red"> **INVALID**</span>
        )}
      </h5>
      <div className="bottom_p">
        <div className="sub-title">
          <span>Facility name :</span> <p>{svcf_name}</p>
        </div>
        <div className="sub-title">
          <span>Order Service Date :</span> <p>{ord_svc_date}</p>
        </div>
        <div className="sub-title">
          <span>Daily Count : </span> <p>{order_count}</p>
        </div>
        <div className="sub-title">
          <span>Daily Total (USD)$ : </span> <b>{svc_provider_cost_amtf}</b>
        </div>
        <div className="sub-title">
          <span>{xchange_rate[0]?.iso_curr_name}:</span>{" "}
          <b>{svc_provider_local_cost_amtf}</b>
        </div>
        <div className="sub-title">
          <span>Your Overall Rating : </span> <p>{svc_rating_num}</p>
        </div>
      </div>
    </div>
  );
};
